import logo from '../../wootic_logo.jpg';

const LogoFull = () => (
  <img src={logo} alt="WOOTIC" style={{ height: 38, width: 'auto', borderRadius: 6 }} />
);

export default LogoFull;
